"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var FormError_exports = {};
__export(FormError_exports, {
  default: () => FormError_default
});
module.exports = __toCommonJS(FormError_exports);
var import_react = __toESM(require("react"));
const FormError = ({
  error,
  wrapperClassName,
  wrapperStyle,
  titleClassName,
  titleStyle,
  listClassName,
  listStyle,
  listItemClassName,
  listItemStyle
}) => {
  if (!error) {
    return null;
  }
  let rootMessage = error.message;
  const messages = [];
  const hasGraphQLError = !!error.graphQLErrors?.[0];
  const hasNetworkError = !!error.networkError && Object.keys(error.networkError).length > 0;
  if (hasGraphQLError) {
    rootMessage = error.graphQLErrors[0].message ?? "Something went wrong";
    if (error.graphQLErrors[0]?.extensions?.code === "BAD_USER_INPUT") {
      rootMessage = "Errors prevented this form from being saved";
    }
    const properties = error.graphQLErrors[0].extensions?.["properties"];
    const propertyMessages = properties?.["messages"];
    if (propertyMessages) {
      for (const e in propertyMessages) {
        propertyMessages[e].forEach((fieldError) => {
          messages.push(fieldError);
        });
      }
    }
  } else if (hasNetworkError) {
    rootMessage = rootMessage ?? "An error has occurred";
    if (Object.prototype.hasOwnProperty.call(error.networkError, "bodyText")) {
      const netErr = error.networkError;
      messages.push(`${netErr.name}: ${netErr.bodyText}`);
    } else if (Object.prototype.hasOwnProperty.call(error.networkError, "result")) {
      const netErr = error.networkError;
      netErr.result.errors?.forEach((error2) => {
        if (typeof error2.message === "string") {
          if (error2.message.indexOf(";") >= 0) {
            messages.push(error2.message?.split(";")[1]);
          } else {
            messages.push(error2.message);
          }
        }
      });
    }
  }
  if (!rootMessage) {
    return null;
  }
  return /* @__PURE__ */ import_react.default.createElement("div", { className: wrapperClassName, style: wrapperStyle }, /* @__PURE__ */ import_react.default.createElement("p", { className: titleClassName, style: titleStyle }, rootMessage), messages.length > 0 && /* @__PURE__ */ import_react.default.createElement("ul", { className: listClassName, style: listStyle }, messages.map((message, index) => /* @__PURE__ */ import_react.default.createElement("li", { key: index, className: listItemClassName, style: listItemStyle }, message))));
};
var FormError_default = FormError;
